import Tabs_ from "common/Tabs";
import React, { useState } from "react";
import styles from "./summary.module.css";
import YourEvents from "./YourEvents";
import Referrals from "./Referrals";
import ClearedBalance from "./ClearedBalance";
import CoPromotion from "./CoPromotion";

const Summary = () =>{

    const [selectedTabIndex, setSelectedTabIndex] = useState(0);

    // const TabList = [{label:"Your Events"},{label:"Co-promotions"} ,{label:"Referrals"},{label:"Cleared balance"}]
    const TabList = [{label:"Cleared balance"}]


    // const TabContent = [{content:<YourEvents/>},{content:<CoPromotion/>}, {content:<Referrals/>},{content:<ClearedBalance/>}]
    const TabContent = [{content:<ClearedBalance/>}]



    return <>
       <Tabs_ 
       TabList_={TabList} 
       TabContent_={TabContent} 
       TabListStyleOverride={styles.TabListClass} 
       selectedIndex={selectedTabIndex} 
       setSelectedIndex={(e)=>setSelectedTabIndex(e)}
       />
    </>

}


export default Summary;